import useTranslation from "./useTranslation";
import USER_LANGUAGES from "../constants/userLanguages";

const useTranslatedLanguages = () => {
  const { t } = useTranslation("common");

  return USER_LANGUAGES.map((language) => ({
    ...language,
    label: t(language.label),
  }));
};

export default useTranslatedLanguages;